import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { FeatureItem } from "./FeatureItem";
import { PlanTrialCard } from "./PlanTrialCard";
import { I18N_LOCALE_ROOT } from "./constants";

interface LeftPaneProps {
  isPlanLoading?: boolean;
  onConfirm: () => void;
  plan?: {
    display_base_monthly_amount?: string;
    display_name?: string;
  };
}

const FEATURES = [
  { key: "community_ai", iconType: "16-thunder" },
  { key: "workflows_apis", iconType: "sw-thunder" },
  { key: "custom_fields", iconType: "16-character-square" },
] as const;

export const LeftPane = ({ onConfirm, plan, isPlanLoading }: LeftPaneProps) => {
  const i18nRoot = `${I18N_LOCALE_ROOT}.left_pane.features`;

  return (
    <div className="flex h-full flex-col pb-6 lg:pb-0">
      <div className="flex-1">
        <div className="mb-6">
          <Typography.BodyMd color="text-subtle">
            {t(`${I18N_LOCALE_ROOT}.left_pane.description`)}
          </Typography.BodyMd>
        </div>

        <div className="space-y-4">
          {FEATURES.map(feature => (
            <FeatureItem
              key={feature.key}
              iconType={feature.iconType}
              title={t(`${i18nRoot}.${feature.key}.title`)}
              description={t(`${i18nRoot}.${feature.key}.description`)}
            />
          ))}
        </div>
      </div>

      <div className="mt-auto">
        <div className="mb-4 lg:hidden">
          <PlanTrialCard plan={plan} isPlanLoading={isPlanLoading} />
        </div>
        <Button
          variant="marketing-gradient"
          large
          onClick={onConfirm}
          className="w-full"
        >
          {t(`${I18N_LOCALE_ROOT}.start_trial`)}
        </Button>
      </div>
    </div>
  );
};
